import React, { useEffect, useState, useContext } from "react";
import { DataContext } from "../context/DataContext";
import { Label } from "@material-ui/icons";
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";


export default function HardwareBestellung() {
    const { appToken, appLoggedInChange, appLdapUsername } = useContext(DataContext);
    const [localFreigeber, setLocalFreigeber] = useState();

      return (
        <div id="wrapper">
        <div className="section_title">Bestellung Hardware</div>
      <div style={{
         padding: "20px 20px",
         color: "#55ba5e",
         // fontWeight: "bold",
         backgroundColor:"#ffffff",
          width:"90%",
         margin:"10px",
         float:"left"
       }}>



          <h2 className='angebote'> Hiermit bestelle ich ({appLdapUsername}) folgende Hardware:</h2>
            <h3>Verwender</h3>
            
            <FormControl fullWidth>
            
            <TextField id="firma" label="Firma" variant="outlined" /><br /><br />
            <TextField id="kostenstelle" label="Kostenstelle" variant="outlined" /><br /><br />
            <TextField id="nutzer" label="Nutzer" variant="outlined" /><br /><br />
            <h3>Freigebender Vorgesetzter</h3>

            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={localFreigeber}
                label="Freigebender Vorgesetzter"

                //@ts-ignore
                onChange={(e)=>setLocalFreigeber(e.target.value)}
            >
                <MenuItem value='ulf.beyer@procuratio.com'>Ulf Beyer</MenuItem>
                <MenuItem value='Jens.muehlenfeld@procuratio.com'>Jens Mühlenfeld</MenuItem>
                <MenuItem value='andreas.geier@procuratio.com'>Andreas Geier</MenuItem>
                <MenuItem value='torsten.truempelmann@procuratio.com'>Torsten Trümpelmann</MenuItem>
                <MenuItem value='verena.landschoof@procuratio.com'>Verena Landschoof</MenuItem>
            </Select>
            <h3>Computer</h3>
            <FormGroup>
                <FormControlLabel control={<Checkbox />} label="stationärer Computer" />
                <FormControlLabel control={<Checkbox />} label="Ausstattung Betrieb (Monitor, Maus, Tastatur)" />
                <FormControlLabel control={<Checkbox />} label="Laptop mobil (12-13Zoll)" />
                <FormControlLabel control={<Checkbox />} label="Laptop groß (>14Zoll)" />
                <FormControlLabel control={<Checkbox />} label="Ausstattung Homeoffice (Monitor, Maus, Tastatur, Docking Station)" />


            </FormGroup>
            <h3>Handy</h3>
                <FormGroup>

                <FormControlLabel control={<Checkbox />} label="Handy Apple" />
                <FormControlLabel control={<Checkbox />} label="Handy Android" />
                </FormGroup>
            <h3>Einzelteile</h3>
                <FormGroup>

                <FormControlLabel control={<Checkbox />} label="Maus und Tastatur" />
                <FormControlLabel control={<Checkbox />} label="Monitor" />
                <FormControlLabel control={<Checkbox />} label="Docking Station" />
                </FormGroup>
            
            <br /><br />
            <h3>Begründung</h3>
            <TextField id="firma" label="Begründung" variant="outlined" /><br /><br />
            <FormGroup>

                <FormControlLabel control={<Checkbox />} label="Erstbeschaffung" />
                <FormControlLabel control={<Checkbox />} label="Ersatzbeschaffung (defekt oder nicht benutzbar)" />
                <FormControlLabel control={<Checkbox />} label="Ersatzbeschaffung (veraltet)" />
                <FormControlLabel control={<Checkbox />} label="Ersatzbeschaffung (Verlust)" />
                </FormGroup>
            <Button variant="contained" onClick={()=>alert('Achtung dies ist noch eine Demo! Die Funktion wird in den nächsten Tagen freigeschaltet')}>absenden</Button>
            </FormControl>
          </div>
          </div>
      )

}